// extracted by mini-css-extract-plugin
export default {"flag":"BookingHeader_flag__Pot4D"};